import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, IconButton, TextField, Typography, InputLabel, MenuItem, Select, FormControl, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const OlympiadSubjectModal = ({ onClose, fetchData, propData }) => {
    const [form, setForm] = useState({ name: "" });
    const [loading, setLoading] = useState(false);
    const [unitPrice, setUnitPrice] = useState("");
    const [name, setName] = useState("");
    const [isStudyMaterial, setIsStudyMaterial] = useState("");
    const [state, setState] = useState("");
      const [olympiadTypes, setOlympiadTypes] = useState([]);
      const [olympiadType, setOlympiadType] = useState("");

        useEffect(()=>{
          getAllOlympiadTypes()
        },[])
      

    useEffect(() => {
        if (propData) {
            setName(propData.subject_name || "");
            setUnitPrice(propData.price ?? "");
            setIsStudyMaterial(propData.isStudyMaterial || "");
            setOlympiadType(propData?.olympiad_type || "")

        }
    }, [propData]);

      async function getAllOlympiadTypes() {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllOlympiadTypes();
            if (response?.status) {
                setOlympiadTypes(response?.data)
            }
            else {
                window.NotificationUtils.showError(response?.message || "Olympiad types dropdown response error")
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
  }

    const submitHandler = async () => {
         if(!olympiadType){
       window.NotificationUtils.showError("Please Select Olympiad Type");
      return;
    }
        if (!name.trim()) {
            window.NotificationUtils.showError("Please fill in Subject Name fields");
            return;
        }
         if(!unitPrice || unitPrice == ""){
       window.NotificationUtils.showError("Please Fill Price");
      return;
    }
        setLoading(true);
        try {
            if (propData) {
                await window.Platform.database.updateOlympiadSubject({
                    subject_name: name,
                    id: propData.id,
                    isStudyMaterial: isStudyMaterial,
                    price: unitPrice,
                    olympiad_type : olympiadType
                });
                window.NotificationUtils.showSuccess("Subject updated successfully");
            } else {
                await window.Platform.database.addOlympiadSubject({ subject_name: name, isStudyMaterial: isStudyMaterial, price: unitPrice,  olympiad_type : olympiadType });
                window.NotificationUtils.showSuccess("Subject saved successfully");
            }
            setName("");
            setIsStudyMaterial("");
            fetchData();
            onClose();
        } catch (err) {
            window.NotificationUtils.showError(err?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
            <StyledDialogContent>
                <ModalHeaderContainer>
                    <Typography variant="h5">
            {propData ? "Update Subject Name" : "Add Subject Name"}
          </Typography>
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>

                {loading && <OpaqueLoading />}

                <Stack gap={2} padding={2}>
                     <FormControl size="small" fullWidth>
                                <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Olympiad Type</InputLabel>
                                <Select
                                  value={olympiadType}
                                  label="Select Olympiad Type"
                                  size="small"
                                  onChange={(e) => { setOlympiadType(e.target.value) }}
                                >
                                  {olympiadTypes.map((type) => (
                                    <MenuItem key={type} value={type.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{type.name}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                    <FormControl fullWidth>

                        <TextField
                            label="Subject Name"
                            value={name || ''}
                            type="text"
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                        />
                    </FormControl>
                     <FormControl fullWidth>
                                            <TextField
                                                label="Unit Price"
                                                value={unitPrice}
                                                type="number"
                                                onChange={(e) => setUnitPrice(e.target.value)}
                                                onWheel={(e) => e.target.blur()}
                                                fullWidth
                                            />
                                        </FormControl>
                    {/* <FormControl fullWidth className="mt-3">
                        <InputLabel id="study-material-label">Is Study Material</InputLabel>
                        <Select
                            labelId="study-material-label"
                            label="Is Study Material"
                            value={isStudyMaterial}
                            onChange={(e) => setIsStudyMaterial(e.target.value)}
                        >
                            <MenuItem value={"yes"}>Yes</MenuItem>
                            <MenuItem value={"no"}>No</MenuItem>
                        </Select>
                    </FormControl> */}

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <Button
                            color="primary"
                            variant="contained"
                            onClick={submitHandler}
                            // disabled={!name}
                        >
                            {propData ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Stack>
            </StyledDialogContent>

        </Dialog>
    );
};

export default OlympiadSubjectModal;
